<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="lateral-filters-search">
    <CustomSelector
      :title="$t('theme')"
      :filters="filters && filters.theme"
      type-filter="theme"
      :searchable="false"
      :multiselect="false"
      :active-filter="activeFilter"
      :toggle-filter="toggleFilter"
      :all-option="$t('all_themes')"
      @lateral-filter-change="lateralFilterChange"
    />
    <CustomSelector
      :title="$t('subtheme')"
      :filters="filteredSubthemes"
      type-filter="subtheme"
      :multiselect="false"
      :active-filter="activeFilter"
      :toggle-filter="toggleFilter"
      :all-option="$t('all_subthemes')"
      :enabled="subthemesAvailables ? true : false"
      :searchable="true"
      :search-filters="searchFilters"
      @lateral-filter-change="lateralFilterChange"
    />
    <CustomSelector
      :title="$t('detail')"
      :filters="detailsAvailable"
      type-filter="detail"
      :multiselect="true"
      :active-filter="activeFilter"
      :toggle-filter="toggleFilter"
      :all-option="$t('all_details')"
      :enabled="detailsAvailable ? true : false"
      @lateral-filter-change="lateralFilterChange"
    />
    <div class="separator" />
    <CustomSelector
      :title="$t('location')"
      :filters="orderedLocations"
      type-filter="territory"
      :multiselect="true"
      :active-filter="activeFilter"
      :toggle-filter="toggleFilter"
      :all-option="$t('all_locations')"
      @lateral-filter-change="lateralFilterChange"
    />
    <!--CustomSelector
        :title="$t('district')"
        :filters="territories && territories.data"
        type-filter="district"
        :multiselect="true"
        :active-filter="activeFilter"
        :toggle-filter="toggleFilter"
        :all-option="$t('all_ditricts')"
        @lateral-filter-change="lateralFilterChange"
      /-->
    <CustomSelector
      :title="$t('update_date')"
      :filters="datesFilterOptions"
      type-filter="publishDateRange"
      :multiselect="false"
      :active-filter="activeFilter"
      :toggle-filter="toggleFilter"
      :all-option="$t('all_dates')"
      :enabled="searchTimeLimits && searchTimeLimits.max && searchTimeLimits.min ? true : false"
      :search-time-limits="searchTimeLimits"
      @lateral-filter-change="lateralFilterChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { collectSubthemesForThemes, findDetailsForSubtheme } from '@/utils/thesaurusUtils'
import CustomSelector from './CustomSelector.vue'
import { t } from '../../i18n/index'
/**
 * Renders the lateral filter with results when search
 * @example [none]
 */
export default {
  name: 'LateralFilters',
  components: { CustomSelector },
  props: {
    /**
     * Is the value of selected filter
     */
    activeFilter: {
      type: String,
    },
    /**
     * Min and max value of time in filters
     */
    searchTimeLimits: {
      type: Object,
    },
    thesaurusFilters: {
      type: Object,
    },
  },
  data() {
    return {
      subthemeSearchTerm: '',
      orderedLocations: [
        'supramunicipal',
        'municipi',
        'districte',
        'barri',
        'area estadistica basica',
        'seccio censal',
        'codi postal',
      ],
    }
  },
  computed: {
    datesFilterOptions() {
      let datesOptionFilter = []
      if (this.searchTimeLimits) {
        let minDate = new Date(this.searchTimeLimits.min)
        let maxDate = new Date(this.searchTimeLimits.max)
        let minRangeDate = dayjs(maxDate).subtract(1, 'month')
        if (!minRangeDate.isBefore(dayjs(minDate)))
          datesOptionFilter.push({ label: t('last_month') })
        minRangeDate = dayjs(maxDate).subtract(3, 'month')
        if (!minRangeDate.isBefore(dayjs(minDate)))
          datesOptionFilter.push({ label: t('last_3_months') })
        minRangeDate = dayjs(maxDate).subtract(1, 'year')
        if (!minRangeDate.isBefore(dayjs(minDate)))
          datesOptionFilter.push({ label: t('last_year') })
      }
      return datesOptionFilter
    },
    selectedSubtheme() {
      return this.$route.query.subtheme
    },
    detailsAvailable() {
      return findDetailsForSubtheme(
        this.filters && this.filters.theme,
        this.$route.query.theme,
        this.selectedSubtheme
      )
    },
    subthemesAvailables() {
      return collectSubthemesForThemes(this.filters && this.filters.theme, this.$route.query.theme)
    },
    filteredSubthemes() {
      if (!this.subthemesAvailables) {
        return []
      }

      if (!this.subthemeSearchTerm || this.subthemeSearchTerm.length === 0) {
        return this.subthemesAvailables
      }

      return this.subthemesAvailables.filter(sub =>
        sub.label.toUpperCase().indexOf(this.subthemeSearchTerm.toUpperCase()) !== -1
      )
    },
    filters() {
      return this.thesaurusFilters
    },
  },
  watch: {
    '$route.query.theme'() {
      this.subthemeSearchTerm = ''
    },
    '$store.state.i18n.lang'() {
      this.subthemeSearchTerm = ''
    },
  },
  methods: {
    /**
     * Toggle one of the lateral filters avaliable
     * @public This is a public method
     * @param {String} filter Id of selected filter to toggle
     */
    toggleFilter(filter) {
      /** Triggers event to toggle
       * @event toggle-filter
       * @property {String} filter name of the filter to toggle
       */
      this.$emit('toggle-filter', filter)
    },
    /**
     * Emits an event to know what filter is pressed and close the opened lateral filter
     * @public This is a public method
     * @param {String} filtVal selected lateralfilter label
     * @param {String} filtType The type of the clicked filter
     * @param {Boolean} multiselect if filter has multiselection enabled or not
     * @param {Boolean} open if selector must stay open
     */
    lateralFilterChange(filtVal, filtType, multiselect, open) {
      if (!open) this.toggleFilter('')
      /** Triggers an event to SearchList with information and close the opened
       * @event lateral-filter-pressed
       * @property {String} filtVal selected lateralfilter label
       * @property {String} filtType The type of the clicked filter
       * @property {Boolean} multiselect if filter has multiselection enabled or not
       */
      this.$emit('lateral-filter-pressed', filtVal, filtType, multiselect)
    },
    /**
     * This function sets the subthemes available filtered with the value typed on search input
     * @public This is a public method
     * @param {String} value String typed by the user
     */
    searchFilters(value) {
      this.subthemeSearchTerm = value
    },
  },
}
</script>

<style lang="stylus" scoped>
.lateral-filters-search
  padding: vw(30px) vw(25px) vw(40px)
  border: 1px solid $bcn-grey
  border-radius: 6px
  background-color: #fff
  box-shadow: 0 0 10px rgba(#000, 0.05)

  .mobile &
    position: relative
    overflow-y: auto
    padding: vw(20px)
    max-height: 80vh
    border: none
    border-radius: none
    box-shadow: none

  .separator
    margin-top: vw(10px)
    margin-bottom: vw(20px)
    width: 100%
    border-bottom: 1px solid $grey
</style>